import { Group, Stack, createStyles, Box, Text } from '@mantine/core';
import React from 'react';

// Custom styles
const useStyles = createStyles((theme) => ({
	barsContainer: {
		minWidth: 300,
		position: 'relative'
	},
	container: {
		height: 50,
		display: 'flex',
		flexFlow: 'column',
		justifyContent: 'center',
	},
	leftContainer: {
		backgroundColor: theme.colors.mainPurple[4]
	},
	rightContainer: {
		backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
	},
	text: {
		fontSize: 14,
		lineHeight: '18px',
	},
	barText: {
		fontWeight: 700,
		fontSize: 14,
		lineHeight: '18px',
	}
}));

const PercentageComparison = ({ leftData, rightData, leftText, rightText }) => {

	// State and hooks
	const { classes, cx } = useStyles();

	// Build percentages
	const leftWidth = (leftData === 0 ? 0 : (leftData * 100 / (leftData + rightData)));
	const rightWidth = (rightData === 0 ? 0 : (rightData * 100 / (leftData + rightData)));

	return (
		<Stack spacing={4}>
			{/* Top */}
			<Group
				spacing={0}
				className={classes.barsContainer}
			>
				{/* Left */}
				<Box
					className={cx(classes.container, classes.leftContainer)}
					style={{
						width: `${leftWidth}%`,
						alignItems: 'flex-start'
					}}
				>
					{/* Percentage */}
					{leftWidth !== 0 ?
						<Text
							className={classes.barText}
							c="white"
							ml={10}
						>
							{`${leftWidth.toFixed(2)}%`}
						</Text>
					: null}
				</Box>
				{/* Right */}
				<Box
					className={cx(classes.container, classes.rightContainer)}
					style={{
						width: `${rightWidth}%`,
						alignItems: 'flex-end'
					}}
				>
					{/* Percentage */}
					{rightWidth !== 0 ?
						<Text
							className={classes.barText}
							mr={10}
						>
							{`${rightWidth.toFixed(2)}%`}
						</Text>
					: null}
				</Box>
			</Group>
			{/* Description */}
			<Group
				spacing={0}
				position="apart"
			>
				{/* Left */}
				<Text className={classes.text}>
					<span style={{ fontWeight: 700 }}>{leftData}</span> {leftText}
				</Text>
				{/* Right */}
				<Text className={classes.text}>
					<span style={{ fontWeight: 700 }}>{rightData}</span> {rightText}
				</Text>
			</Group>
		</Stack>
	);

}

export default PercentageComparison;
